"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMappedTheme = void 0;
var react_1 = require("@emotion/react");
var LinearProgress_1 = __importDefault(require("@mui/material/LinearProgress"));
var styles_1 = require("@mui/material/styles");
var react_2 = __importDefault(require("react"));
var palette_1 = require("./palette");
function getMappedTheme(mode) {
    var _a;
    var _b;
    var theme = (0, styles_1.createTheme)({
        palette: mode === 'dark' ? palette_1.DarkPalette : palette_1.LightPalette,
    });
    var buttonBase = {
        defaultProps: {
            disableElevation: true,
            disableRipple: true,
            color: 'primary',
            variant: 'contained',
            size: 'large',
        },
        styleOverrides: {
            root: {
                textTransform: 'none',
                fontWeight: 'bold',
                borderRadius: 2,
                transition: 'none',
                lineHeight: '1',
                paddingTop: '0',
                paddingBottom: 0,
            },
            sizeLarge: {
                fontSize: 17,
                letterSpacing: -0.5,
                height: 48,
            },
            sizeMedium: {
                fontSize: 14,
                height: 35,
            },
            sizeSmall: {
                fontSize: 12,
                height: 28,
            },
            iconSizeLarge: {
                '>svg': {
                    position: 'relative',
                    top: -0.5,
                    fontSize: '24px !important',
                },
            },
            iconSizeMedium: {
                '&.MuiButton-startIcon': {
                    marginRight: 6,
                },
                '>svg': {
                    position: 'relative',
                    top: 0.5,
                    fontSize: '22px !important',
                },
            },
            iconSizeSmall: {
                '&.MuiButton-startIcon': {
                    marginRight: 3,
                },
                '>svg': {
                    position: 'relative',
                    top: 1.2,
                    fontSize: '20px !important',
                },
            },
        },
    };
    theme = (0, styles_1.createTheme)(theme, {
        components: {
            MuiCssBaseline: {
                styleOverrides: (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          * {\n            font-family: NeueHansKendrick, system-ui, -apple-system, Segoe UI,\n              Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif,\n              BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n              'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',\n              'Segoe UI Symbol', 'Noto Color Emoji' !important;\n          }\n\n          html,\n          body {\n            padding: 0;\n            margin: 0;\n            line-height: 1.5;\n            height: 100%;\n            overflow: auto;\n            background-color: white;\n          }\n\n          #__next {\n            height: 100%;\n          }\n\n          .CodeMirror-info-header {\n            .field-name,\n            .arg-name {\n              pointer-events: none !important;\n            }\n          }\n        "], ["\n          * {\n            font-family: NeueHansKendrick, system-ui, -apple-system, Segoe UI,\n              Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif,\n              BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n              'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',\n              'Segoe UI Symbol', 'Noto Color Emoji' !important;\n          }\n\n          html,\n          body {\n            padding: 0;\n            margin: 0;\n            line-height: 1.5;\n            height: 100%;\n            overflow: auto;\n            background-color: white;\n          }\n\n          #__next {\n            height: 100%;\n          }\n\n          .CodeMirror-info-header {\n            .field-name,\n            .arg-name {\n              pointer-events: none !important;\n            }\n          }\n        "]))).styles,
            },
            MuiButton: buttonBase,
            MuiLoadingButton: __assign(__assign({}, buttonBase), { defaultProps: __assign(__assign({}, buttonBase === null || buttonBase === void 0 ? void 0 : buttonBase.defaultProps), { loadingIndicator: react_2.default.createElement(LinearProgress_1.default, { color: "inherit" }) }), styleOverrides: __assign(__assign({}, buttonBase === null || buttonBase === void 0 ? void 0 : buttonBase.styleOverrides), { root: __assign(__assign({}, (_b = buttonBase === null || buttonBase === void 0 ? void 0 : buttonBase.styleOverrides) === null || _b === void 0 ? void 0 : _b.root), { '.MuiLinearProgress-root': {
                            width: '100%',
                        }, '.MuiLoadingButton-loadingIndicator': {
                            width: '50%',
                        } }) }) }),
            MuiFormHelperText: {
                styleOverrides: {
                    root: {
                        marginLeft: 0,
                        marginTop: 6,
                        fontSize: 11,
                    },
                },
            },
            MuiInputLabel: {
                defaultProps: {
                    variant: 'outlined',
                    disableAnimation: true,
                    shrink: true,
                },
                styleOverrides: {
                    root: {
                        transform: 'none',
                        fontWeight: 'bold',
                        display: 'block',
                        position: 'unset',
                        lineHeight: 1,
                        fontSize: 14,
                        color: theme.palette.text.primary,
                        marginBottom: 5,
                    },
                },
            },
            MuiTextField: {
                defaultProps: {
                    color: 'primary',
                    variant: 'outlined',
                },
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    notchedOutline: {
                        borderWidth: '1px !important',
                        borderColor: theme.palette.text.disabled,
                    },
                    root: {
                        borderRadius: 2,
                        height: 48,
                        fontSize: 16,
                        lineHeight: 1,
                        background: theme.palette.background.default,
                        '&.MuiInputBase-multiline': {
                            height: 'auto',
                        },
                        '.MuiInputAdornment-root': {
                            color: theme.palette.text.disabled,
                            marginRight: 4,
                        },
                        '&.Mui-focused .MuiInputAdornment-root': {
                            color: theme.palette.primary.main,
                        },
                        input: {
                            padding: '14px 16px',
                            fontSize: 16,
                            height: 'auto',
                        },
                        '&.MuiInputBase-sizeSmall': {
                            height: 32,
                            lineHeight: 1,
                            fontSize: 14,
                            input: {
                                padding: '7px 10px',
                                fontSize: 14,
                                height: 'auto',
                            },
                            '.MuiInputAdornment-root': {
                                marginRight: 0,
                                svg: {
                                    width: 18,
                                    height: 18,
                                },
                            },
                        },
                        'fieldset legend': {
                            maxWidth: '0.01px !important',
                        },
                        '&.Mui-focused .MuiSelect-iconOutlined': {
                            color: theme.palette.primary.main,
                        },
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        background: theme.palette.background.default,
                        borderRadius: 2,
                        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 6px 0px',
                        border: "1px solid ".concat(theme.palette.divider),
                    },
                },
            },
            MuiSelect: {
                defaultProps: {
                    size: 'medium',
                },
                styleOverrides: {
                    select: {
                        minHeight: 0,
                    },
                },
            },
            MuiMenuItem: {
                defaultProps: {
                    disableRipple: true,
                },
                styleOverrides: {
                    root: {
                        '&.Mui-selected': {
                            background: theme.palette.action.hover + ' !important',
                        },
                        '&[role="option"]': {
                            paddingTop: 12,
                            paddingBottom: 12,
                        },
                    },
                },
            },
            MuiDataGrid: {
                styleOverrides: {
                    root: (_a = {
                            borderColor: theme.palette.divider,
                            '.MuiDataGrid-columnHeader': {
                                textTransform: 'capitalize',
                            },
                            '.MuiDataGrid-row.Mui-selected': {
                                backgroundColor: 'rgba(74, 59, 207, 0.05) !important',
                            },
                            '.MuiDataGrid-row:hover': {
                                backgroundColor: 'rgba(246, 246, 246, 0.5)',
                            }
                        },
                        _a["\n            .MuiDataGrid-columnHeaders, \n            .MuiDataGrid-columnHeader, \n            .MuiDataGrid-cell, \n            .MuiDataGrid-cell:focus, \n            .MuiDataGrid-row--lastVisible,\n            .MuiDataGrid-columnHeaderTitleContainer"] = {
                            borderColor: "".concat(theme.palette.divider, " !important"),
                            outline: 'none !important',
                        },
                        _a['.MuiDataGrid-columnHeaders'] = {
                            borderBottom: "1px solid",
                            borderTop: "none",
                        },
                        _a['.MuiDataGrid-columnHeaderTitleContainer'] = {
                            textTransform: 'uppercase',
                        },
                        _a['.MuiDataGrid-cell, .MuiDataGrid-columnHeader'] = {
                            borderLeft: "1px solid",
                            '&:first-of-type': {
                                borderLeft: "none",
                            },
                            '&:last-of-type': {
                                borderRight: 'none',
                            },
                        },
                        _a['.MuiDataGrid-columnSeparator svg'] = {
                            opacity: '0',
                        },
                        _a['&.borderless'] = {
                            '.MuiDataGrid-cell, .MuiDataGrid-columnHeader': {
                                borderLeft: 'none',
                            },
                        },
                        _a['.MuiDataGrid-row--lastVisible .MuiDataGrid-cell'] = {
                            borderBottom: 'none !important',
                        },
                        _a['.MuiLinearProgress-root'] = {
                            zIndex: '50',
                            width: '110%',
                        },
                        _a['&.loading'] = {
                            '.MuiDataGrid-virtualScroller': {
                                height: '4px !important',
                                overflow: 'hidden !important',
                            },
                        },
                        _a),
                },
            },
        },
    });
    return theme;
}
exports.getMappedTheme = getMappedTheme;
var templateObject_1;
